module.exports = __webpack_public_path__ + "static/media/trainee_tm.efd43625.svg";